import { Stack, Typography } from '@mui/material';
import { ControlledTextField } from 'Components/ControlledTextField';
import { OTPLoginContext } from 'Context/OTPLoginContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useContext } from 'react';

const IsrIdLength = 9;

export const PersonalDetails = () => {
  const { userDetails, setUserDetails, errors, setErrors } =
    useContext(OTPLoginContext);
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.OTP_Login
  ).personalDetailsForm;

  return (
    <Stack
      direction='column'
      gap='16px'
      mb={isDesktop ? '40px' : '24px'}
      component='fieldset'
    >
      <Typography
        variant={'body1'}
        component='legend'
        display={'block'}
        mb='16px'
      >
        {dictionary.personalDetailsTitle}
      </Typography>
      <ControlledTextField
        name='firstName'
        label={dictionary.firstName}
        ariaLabel={dictionary.firstName}
        ariaRequired
        value={userDetails.firstName}
        setValue={(value: string) =>
          setUserDetails({ ...userDetails, firstName: value.trim() })
        }
        showError
        inputRegexType='NAME'
        error={errors.firstName}
        setError={(error: string | null) =>
          setErrors({ ...errors, firstName: error })
        }
      />
      <ControlledTextField
        name='lastName'
        label={dictionary.lastName}
        ariaLabel={dictionary.lastName}
        ariaRequired
        value={userDetails.lastName}
        setValue={(value: string) =>
          setUserDetails({ ...userDetails, lastName: value.trim() })
        }
        showError
        inputRegexType='NAME'
        error={errors.lastName}
        setError={(error: string | null) =>
          setErrors({ ...errors, lastName: error })
        }
      />
      <ControlledTextField
        inputMode='numeric'
        name='IsrId'
        label={dictionary.idNumber}
        ariaLabel={dictionary.idNumber}
        ariaRequired
        value={userDetails.IsrId}
        type='tel'
        setValue={(value: string) =>
          setUserDetails({ ...userDetails, IsrId: value })
        }
        showError
        inputLimit={IsrIdLength}
        inputRegexType='ID'
        error={errors.IsrId}
        setError={(error: string | null) =>
          setErrors({ ...errors, IsrId: error })
        }
      />
    </Stack>
  );
};
